module.exports = __webpack_public_path__ + "img/t4-i17.d7052dab.svg";